import { createSlice } from '@reduxjs/toolkit';
import { loginUser, registerUser } from './auth_actions';

const initialState = {
    loading: false,
    userInfo: null,
    userToken: null,
    permissions: null,
    error: null,
    isLoggedIn: false,
    success: false
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        updateUserProfile: (state, { payload }) => {
            state.userInfo = payload.user || state.userInfo;
            if (payload.permissions) {
                state.permissions = payload.permissions;
            }
        },
        logoutUser: (state) => {
            state.userInfo = null;
            state.userToken = null;
            state.success = false;
            state.loading = false;
            state.error = null;
            state.isLoggedIn = false;
            state.permissions = null;
        },
        loginWithoutAPI: (state, { payload }) => {
            state.isLoggedIn = true;
            state.userInfo = { email: payload.email };
        },
        updateUserInfo: (state, { payload }) => {
            state.userInfo = payload;
        },
        updateGroupAdminInfo: (state, { payload }) => {
            // Save the token, role, user object, etc.
            state.userToken = payload.token || null;
            state.userInfo = payload.user || null;
            if (payload.permissions) {
                state.permissions = payload.permissions;
            }
            state.isLoggedIn = true;
            state.loading = false;
            state.error = null;
        },
        updateDefaultCardId: (state, { payload }) => {
            state.userInfo = { ...state.userInfo, defaultCardId: payload.defaultCardId };
        },
        sendOtp: (state) => {
            state.success = false;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(loginUser.pending, (state) => {
                state.userInfo = null;
                state.userToken = null;
                state.loading = true;
                state.error = null;
                state.isLoggedIn = false;
            })
            .addCase(loginUser.fulfilled, (state, { payload }) => {
                state.userInfo = payload.user;
                state.userToken = payload.token;
                if (payload.permissions) {
                    state.permissions = payload.permissions;
                }
                state.loading = false;
                state.error = null;
                state.isLoggedIn = true;
            })
            .addCase(loginUser.rejected, (state, { payload }) => {
                state.userInfo = null;
                state.userToken = null;
                state.loading = false;
                state.error = payload;
                state.isLoggedIn = false;
            })
            .addCase(registerUser.pending, (state) => {
                state.userInfo = null;
                state.userToken = null;
                state.loading = true;
                state.error = null;
                state.isLoggedIn = false;
            })
            .addCase(registerUser.fulfilled, (state, { payload }) => {
                state.userInfo = payload.user;
                state.userToken = payload.token;
                state.loading = false;
                state.error = null;
                state.isLoggedIn = true;
            })
            .addCase(registerUser.rejected, (state, { payload }) => {
                state.userInfo = null;
                state.userToken = null;
                state.loading = false;
                state.error = payload;
                state.isLoggedIn = false;
            });
    }
});

export const {
    logoutUser,
    loginWithoutAPI,
    updateUserInfo,
    updateGroupAdminInfo,
    updateDefaultCardId,
    updateUserProfile
} = authSlice.actions;
export default authSlice.reducer;
